import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { B2BReceiptHeroTileModel } from '@/types/B2BcontentServerContract';
import ReceiptConfirmation from '@/b2b/receipt/ui/ReceiptConfirmation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BReceiptHeroTile',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReceiptConfirmation))
}
}

})